<template>
  <div data-app class="principal">
    <div class="sidebar-menu">
      <div class="sidebar-header">
        <router-link to="/">
          <img src="@/assets/images/logo.png" alt="" class="logo" />
        </router-link>
      </div>
      <div class="sidebar-menu-nav">
        <ListMenu :groups="groups" />
      </div>
    </div>
    <div class="sidebar-menu-mobile">
      <v-toolbar>
        <v-toolbar-title> Documentação </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar>
      <v-navigation-drawer v-model="drawer" absolute temporary>
        <v-list-item>
          <img src="@/assets/images/logo.png" class="logo" />
          <v-list-item-content>
            <v-list-item-title>Documentação</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <ListMenu :groups="groups" />
      </v-navigation-drawer>
    </div>
    <div class="main-content">
      <div class="main-content-header">
        <SearchList :groups="groups" @searchSelect="searchSelect" />
        <!-- <div class="suporte">
          <router-link to="/">Suporte e-SUS APS</router-link>
        </div> -->
      </div>
      <router-view />
    </div>
  </div>
</template>
<script>
import ListMenu from './Partials/ListMenu/ListMenu.vue'
import SearchList from './Partials/SearchList/SearchList.vue'
import { ListaMixin } from './Mixins/Lista'
export default {
  mixins: [ListaMixin],
  metaInfo: {
    title: 'Documentação',
    titleTemplate: null,
  },
  components: {
    ListMenu,
    SearchList,
  },
  data() {
    return {
      groupSelected: null,
      isMenuOpen: false,
      groupActive: null,
      drawer: true,
    }
  },
  created() {
    if (innerWidth < 600) {
      this.drawer = false
    }
  },
  methods: {
    searchSelect(event) {
      this.groupSelected = event
      this.setAllExpandedFalse(this.groups)
      this.setParentsExpandedTrue(this.groupSelected, this.groups)
    },
    handleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    setParentsExpandedTrue(item, items) {
      for (const parentItem of items) {
        if (parentItem === item) {
          parentItem.expanded = true
          return true
        } else if (parentItem.children) {
          if (this.setParentsExpandedTrue(item, parentItem.children)) {
            parentItem.expanded = true
            return true
          }
        }
      }
      return false
    },
    setAllExpandedFalse(items) {
      for (const item of items) {
        item.expanded = false
        if (item.children) {
          this.setAllExpandedFalse(item.children)
        }
      }
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
